import SurveyTableContentList from './SurveyTableContentList.vue';

export default SurveyTableContentList;
